import {
  DeleteOutlined,
  EditOutlined,
  PlusOutlined,
} from "@ant-design/icons";
import { Popconfirm, Tooltip, message } from "antd";
import type { TableColumnsType } from "antd";
import { productApi } from "api/product.api";
import { productPropertyApi } from "api/product-property.api";
import { AppButton, AppTable } from "components/antd-ui";
import { ActionButton } from "components/table";
import { useEffect, useState } from "react";
import { ModalStatus } from "types/modal";
import { Product, ProductProperty } from "types/product";
import { ProductPropertyModal } from "./ProductPropertyModal";

export const ProductPropertyTab = ({ productId = 0 }) => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState<ProductProperty[]>([]);
  const [visibleModal, setVisibleModal] = useState(false);
  const [selectedProductProperty, setSelectedProductProperty] = useState<
    Partial<Product>
  >({});
  const [modalStatus, setModalStatus] = useState<ModalStatus>("create");

  useEffect(() => {
    if (productId) {
      fetchData();
    }
  }, [productId]);

  const fetchData = async () => {
    setLoading(true);
    const res = await productApi.findOne(productId);
    setLoading(false);
    setData(res.data.productProperties);
  };

  const handleDelete = async (row: ProductProperty) => {
    setLoading(true);
    try {
      await productPropertyApi.delete(row.id);
      message.success("Xóa thành công");
      fetchData();
    } finally {
      setLoading(false);
    }
  };

  const columns: TableColumnsType<ProductProperty> = [
    {
      title: "Key",
      dataIndex: "key",
      key: "key",
    },
    {
      title: "Giá trị",
      dataIndex: "value",
      key: "value",
    },
    {
      title: "Thao tác",
      key: "action",
      width: 120,
      align: "center",
      render: (_, record) => (
        <div className="flex gap-2 justify-center items-center">
          <Tooltip title="Cập nhật">
            <ActionButton
              aria-label="Cập nhật"
              onClick={() => {
                setSelectedProductProperty(record);
                setVisibleModal(true);
                setModalStatus("update");
              }}
            >
              <EditOutlined style={{ color: "#6c84e5" }} />
            </ActionButton>
          </Tooltip>
          <Tooltip title="Xóa">
            <Popconfirm
              onConfirm={() => handleDelete(record)}
              placement="top"
              title="Xác nhận xóa"
            >
              <ActionButton aria-label="Xóa">
                <DeleteOutlined style={{ color: "#ef4444" }} />
              </ActionButton>
            </Popconfirm>
          </Tooltip>
        </div>
      ),
    },
  ];

  return (
    <div>
      <div style={{ marginBottom: 12 }}>
        <AppButton
          tone="primary"
          icon={<PlusOutlined />}
          onClick={() => {
            setVisibleModal(true);
            setModalStatus("create");
            setSelectedProductProperty({});
          }}
        >
          Thêm mới
        </AppButton>
      </div>

      <AppTable<ProductProperty>
        rowKey="id"
        loading={loading}
        pagination={false}
        dataSource={data}
        columns={columns}
        scroll={{ x: 400 }}
      />

      <ProductPropertyModal
        productId={productId}
        onSubmitOk={fetchData}
        onClose={() => setVisibleModal(false)}
        visible={visibleModal}
        productProperty={selectedProductProperty}
        status={modalStatus}
      />
    </div>
  );
};
